export default __webpack_public_path__ + "images/8889d223f899abe08aee001d04ac61e4-family.webp";